var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiaryCategoryDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8945 4.88281H8.20312C6.36937 4.88281 4.88281 6.36937 4.88281 8.20312V41.8945C4.88281 43.7283 6.36937 45.2148 8.20312 45.2148H41.8945C43.7283 45.2148 45.2148 43.7283 45.2148 41.8945V8.20312C45.2148 6.36937 43.7283 4.88281 41.8945 4.88281Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5078 19.4336H11.4258C10.8864 19.4336 10.4492 19.8708 10.4492 20.4102V29.6875C10.4492 30.2268 10.8864 30.6641 11.4258 30.6641H20.5078C21.0472 30.6641 21.4844 30.2268 21.4844 29.6875V20.4102C21.4844 19.8708 21.0472 19.4336 20.5078 19.4336Z",
    fill: "#20639B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 30.6641H29.5898C29.0505 30.6641 28.6133 31.1013 28.6133 31.6406V40.7227C28.6133 41.262 29.0505 41.6992 29.5898 41.6992H38.6719C39.2112 41.6992 39.6484 41.262 39.6484 40.7227V31.6406C39.6484 31.1013 39.2112 30.6641 38.6719 30.6641Z",
    fill: "#FFC450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 8.39844H29.5898C29.0505 8.39844 28.6133 8.83566 28.6133 9.375V18.457C28.6133 18.9964 29.0505 19.4336 29.5898 19.4336H38.6719C39.2112 19.4336 39.6484 18.9964 39.6484 18.457V9.375C39.6484 8.83566 39.2112 8.39844 38.6719 8.39844Z",
    fill: "#DE2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6312 19.3082C22.5314 19.3082 22.4339 19.2784 22.3511 19.2227C22.2682 19.1671 22.2039 19.088 22.1662 18.9956C22.1285 18.9032 22.1191 18.8016 22.1393 18.7039C22.1595 18.6062 22.2084 18.5167 22.2797 18.4468L27.1247 13.6946C27.2198 13.6012 27.3482 13.5495 27.4815 13.5508C27.6147 13.5521 27.7421 13.6063 27.8354 13.7014C27.9287 13.7966 27.9804 13.9249 27.9791 14.0582C27.9778 14.1915 27.9237 14.3188 27.8285 14.4121L22.9831 19.1645C22.8892 19.2567 22.7628 19.3084 22.6312 19.3082Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.477 35.8473C27.3454 35.8474 27.2192 35.7957 27.1254 35.7035L22.2796 30.9513C22.1844 30.8579 22.1302 30.7306 22.1289 30.5973C22.1276 30.4641 22.1793 30.3357 22.2727 30.2405C22.366 30.1454 22.4933 30.0912 22.6266 30.0899C22.7599 30.0886 22.8882 30.1403 22.9834 30.2336L27.8289 34.9859C27.9002 35.0558 27.949 35.1453 27.9693 35.243C27.9895 35.3408 27.9801 35.4423 27.9424 35.5347C27.9047 35.6271 27.8403 35.7062 27.7575 35.7619C27.6747 35.8176 27.5772 35.8473 27.4774 35.8474L27.477 35.8473Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaryCategoryDefault);
export default __webpack_public_path__ + "static/media/beneficiary_category_default.309cd785464bceae5c26525ecfb30bd5.svg";
export { ForwardRef as ReactComponent };